import { Terminal, ShieldCheck } from "lucide-react";

export function RWALandingHeader({ onLaunch }: { onLaunch: () => void }) {
    return (
        <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4">
            <div className="max-w-7xl mx-auto bg-neutral-950/50 backdrop-blur-md border border-white/5 rounded-full px-6 py-3 flex items-center justify-between">
                {/* Logo Area */}
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-emerald-500 rounded-lg flex items-center justify-center shadow-[0_0_15px_rgba(16,185,129,0.3)]">
                        <ShieldCheck className="w-5 h-5 text-black" />
                    </div>
                    <span className="font-bold tracking-tight text-white hidden md:block">
                        RWA<span className="text-emerald-500">Protocol</span>
                    </span>
                </div>

                {/* Desktop Nav */}
                <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-neutral-400">
                    <a href="#features" className="hover:text-white transition-colors">Features</a>
                    <a href="#compliance" className="hover:text-white transition-colors">Compliance</a>
                    <a href="#institutions" className="hover:text-white transition-colors">Institutions</a>
                    <a href="#docs" className="hover:text-white transition-colors">Docs</a>
                </nav>

                {/* CTA */}
                <button
                    onClick={onLaunch}
                    className="bg-white text-black text-xs md:text-sm font-bold px-4 py-2 md:px-5 md:py-2.5 rounded-full hover:bg-neutral-200 transition-colors flex items-center gap-2"
                >
                    <Terminal className="w-3 h-3 md:w-4 md:h-4" />
                    <span className="hidden md:inline">Launch Terminal</span>
                    <span className="md:hidden">Launch</span>
                </button>
            </div>
        </header>
    );
}

export function RWALandingFooter() {
    return (
        <footer className="bg-neutral-950 border-t border-neutral-900 py-12 text-sm">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
                    <div>
                        <h4 className="font-bold text-white mb-4">Platform</h4>
                        <ul className="space-y-2 text-neutral-500">
                            <li><a href="#" className="hover:text-emerald-500">Markets</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Exchange</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Earn</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Institutional</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold text-white mb-4">Support</h4>
                        <ul className="space-y-2 text-neutral-500">
                            <li><a href="#" className="hover:text-emerald-500">Help Center</a></li>
                            <li><a href="#" className="hover:text-emerald-500">API Documentation</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Fees</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Security</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold text-white mb-4">Legal</h4>
                        <ul className="space-y-2 text-neutral-500">
                            <li><a href="#" className="hover:text-emerald-500">Privacy Policy</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Terms of Service</a></li>
                            <li><a href="#" className="hover:text-emerald-500">Risk Disclosure</a></li>
                            <li><a href="#" className="hover:text-emerald-500">KYC/AML</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold text-white mb-4">Contact</h4>
                        <p className="text-neutral-500 mb-2">institutional@rwaprotocol.com</p>
                        <div className="flex gap-4 mt-4">
                            {/* Socials Mock */}
                            <div className="w-8 h-8 bg-neutral-900 rounded-full flex items-center justify-center text-neutral-500 hover:bg-emerald-500 hover:text-black transition-colors cursor-pointer">X</div>
                            <div className="w-8 h-8 bg-neutral-900 rounded-full flex items-center justify-center text-neutral-500 hover:bg-emerald-500 hover:text-black transition-colors cursor-pointer">in</div>
                        </div>
                    </div>
                </div>
                <div className="pt-8 border-t border-neutral-900 flex flex-col md:flex-row items-center justify-between text-neutral-600 gap-4">
                    <p>&copy; 2024 RWA Protocol Inc. All rights reserved.</p>
                    <p className="flex items-center gap-2">
                        <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
                        System Operational
                    </p>
                </div>
            </div>
        </footer>
    )
}
